/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
import { defineMessages } from 'react-intl';

export default defineMessages({
  Invalid: {
    id: 'ValidationError.PostalCode.Invalid',
    defaultMessage: 'Postal code must be either 5 or 9 digits.'
  }
});
